/** Iter249 · Outreach tab-bar.
 *
 * Three "tabs" (Compose / Sequences / Blacklist) rendered under the
 * AppHeader on all three Outreach-related pages. Because they're real
 * routes, deep-links keep working and each page owns its own state.
 * The tab bar just provides one-click switching so the operator no
 * longer needs the sidebar for these three related pages.
 */
import { Link as _RouterLink } from "react-router-dom";
import { Send, ListChecks, Ban } from "lucide-react";

const TABS = [
  { key: "outreach",   label: "Compose",    route: "/smith/outreach",   icon: Send },
  { key: "sequences",  label: "Sequences",  route: "/smith/sequences",  icon: ListChecks },
  { key: "blacklist",  label: "Blacklist",  route: "/smith/blacklist",  icon: Ban },
];

export default function OutreachTabBar({ current }) {
  const base = "h-8 px-3 rounded-md text-[11.5px] font-extrabold uppercase tracking-widest inline-flex items-center gap-1.5 transition-colors";
  const active = "bg-[#F59E0B] text-white shadow-sm";
  const idle = "text-slate-400 hover:text-slate-100";
  return (
    <div className="inline-flex items-center gap-1 rounded-lg border border-white/10 bg-black/40 p-1"
         data-testid="outreach-tab-bar">
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <_RouterLink key={t.key} to={t.route}
                         data-testid={`outreach-tab-${t.key}`}
                         className={`${base} ${current === t.key ? active : idle}`}>
            <Icon className="w-3.5 h-3.5" />
            {t.label}
          </_RouterLink>
        );
      })}
    </div>
  );
}
